import React from "react";
import styled from "styled-components";
import { AccountState } from "Types/state";
import { getCreditRatingTerms } from "./lib";

const Description = styled("div")`
    color: ${(props) => props.theme.palette.grey[80]};
    font-size: 14px;
    margin: 20px auto 11px;
    text-align: center;
    width: 90%;

    ${(props) => props.theme.breakpoints.up("tablet")} {
        text-align: left;
    }
`;

const CreditRatingTerms = ({ accountName }: { accountName: AccountState["name"] }) => {
    return (
        <>
            <Description>{getCreditRatingTerms(accountName)}</Description>
        </>
    );
};

export default CreditRatingTerms;
